export function PrivacyPolicy() {
  return (
    <div style={{ minHeight: '100vh', background: '#ffffff', color: '#111827' }}><div style={{ maxWidth: 680, margin: '0 auto', padding: '48px 24px', fontFamily: 'system-ui, sans-serif', lineHeight: 1.7 }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>Política de Privacidad</h1>
      <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 32 }}>Última actualización: mayo 2026</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32, marginBottom: 8 }}>1. Información que recopilamos</h2>
      <p>Proclaim recopila únicamente la información necesaria para brindar el servicio: nombre, dirección de correo electrónico e información de organización (iglesia o grupo). Si usas inicio de sesión con Google o Facebook, recibimos solo el nombre y correo que esos servicios comparten con tu consentimiento.</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32, marginBottom: 8 }}>2. Uso de la información</h2>
      <p>La información se usa exclusivamente para:</p>
      <ul style={{ paddingLeft: 20 }}>
        <li>Autenticar y gestionar tu cuenta.</li>
        <li>Permitir la colaboración dentro de tu organización.</li>
        <li>Enviarte notificaciones relacionadas con tu cuenta (cambios de contraseña, invitaciones, etc.).</li>
      </ul>
      <p>No vendemos ni compartimos tu información con terceros con fines comerciales.</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32, marginBottom: 8 }}>3. Almacenamiento</h2>
      <p>La autenticación es gestionada por <strong>Clerk</strong> (clerk.com), un proveedor seguro de identidad. Los datos de presentaciones, canciones y Biblia se almacenan en servidores propios protegidos con HTTPS.</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32, marginBottom: 8 }}>4. Tus derechos</h2>
      <p>Puedes solicitar la eliminación de tus datos en cualquier momento escribiendo a <a href="mailto:germanisaicreative@gmail.com" style={{ color: '#E00035' }}>germanisaicreative@gmail.com</a> o usando la sección de eliminación de datos en la aplicación.</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32, marginBottom: 8 }}>5. Cookies</h2>
      <p>Usamos cookies de sesión estrictamente necesarias para mantener tu inicio de sesión. No usamos cookies de rastreo publicitario.</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32, marginBottom: 8 }}>6. Contacto</h2>
      <p>Para preguntas sobre privacidad: <a href="mailto:germanisaicreative@gmail.com" style={{ color: '#E00035' }}>germanisaicreative@gmail.com</a></p>

      <p style={{ marginTop: 48, color: '#9ca3af', fontSize: 13 }}>© {new Date().getFullYear()} Proclaim · Todos los derechos reservados</p>
    </div></div>
  );
}
